import { FC, useState } from 'react'
import { Stack, Typography } from '@mui/material'

import { BorderBoxWrapper } from 'components/common/BorderBoxWrapper'
import { EditWorkspaceNameModal } from './EditWorkspaceNameModal.component'
import { GRAY_900 } from 'constants/styling/theme'
import { MUIButton } from 'components/common/MUIButton'
import { MUIInputField } from 'components/common/MUIInputField'
import { useTranslation } from 'react-i18next'
import { useUserData } from 'components/contexts/UserDataContext'

export const WorkspaceInformationModule: FC = () => {
  const { t } = useTranslation(['workspace_settings'])
  const { currentUserWorkspace } = useUserData()

  const originalName = currentUserWorkspace?.name || ''

  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <Stack gap="1.6rem">
      <Typography variant="text-xl" fontWeight={600} color={GRAY_900}>
        {t('workspace_settings:information.title')}
      </Typography>

      <BorderBoxWrapper padding={2.4} gap={1.6} display="inline-grid">
        <Stack direction="row" alignItems="flex-end" gap={1.6}>
          <Stack width="42rem">
            <MUIInputField label={t('workspace_settings:information.workspace_name')} value={originalName} disabled />
          </Stack>

          <Stack padding=".6rem 0">
            <MUIButton type="secondaryBorder" size="sm" sx={{ width: 'content-fit' }} onClick={() => setIsModalOpen(true)}>
              {t('workspace_settings:information.edit_workspace_name')}
            </MUIButton>
          </Stack>
        </Stack>
      </BorderBoxWrapper>

      <EditWorkspaceNameModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} workspaceId={currentUserWorkspace?.id || ''} currentName={originalName} />
    </Stack>
  )
}
